import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUser, getUserFactoryId } from "../../../..";
import { fetchTableOdata, fetchTableFunilOdata } from "./ApprovalCrud";
import _ from 'lodash'


/**
 * @method
 * @returns {OdataResponse<Workflow>}
 */
export const featchApprovalFlow = createAsyncThunk(
    'approvalflow/featchApprovalFlow',
    async (args, { getState, rejectWithValue }) => {
        const { pagination, filters } = getState().workflow
        /**
         * @constant
         * @type {import("odata-query").Filter}
         */
        let filterStandard = {
            standard: {
                structure: {
                    factoryId: getUserFactoryId()
                },
            },
        };
        let filterFunil = {
            funil: {
                structure: {
                    factoryId: getUserFactoryId()
                },
            },
            and:
            {
                Question1: false,
                Question2: false,
                Question3: false,
                Question4: false,
                Question5: false,
                Question6: false,
                Question7: false
            }
        };
        var filterFunilAuthorship = '';

        // identifier
        if (!_.isEmpty(filters.identifier)) {
            filterStandard = _.merge(filterStandard, {
                and: {
                    standard: {
                        identifier: {
                            contains: filters.identifier
                        }
                    }
                }
            })
        }

        // Name
        if (!_.isEmpty(filters.name)) {
            filterStandard = _.merge(filterStandard, {
                and: {
                    standard: {
                        name: {
                            contains: filters.name
                        }
                    }
                }
            })
            filterFunil = _.merge(filterFunil, {
                Activity: {
                    contains: filters.name
                }
            })
        }

        // User
        if (!_.isEmpty(filters.user)) {
            //console.log('user')
            filterStandard = _.merge(filterStandard, {
                standard: {
                    user: {
                        name: {
                            contains: filters.user
                        }
                    }
                }
            })
            filterFunil = _.merge(filterFunil, {
                funil: {
                    GTMUser: {
                        name: {
                            contains: filters.user
                        }
                    }
                }
            })
        }

        // Type
        if (!_.isEmpty(filters.type)) {
            filterStandard = _.merge(filterStandard, {
                standard: {
                    standardType: filters.type.value
                }
            })
        }

        // Status
        if (!_.isEmpty(filters.status)) {
            filterStandard = _.merge(filterStandard, {
                situation: filters.status
            })
            
            switch (filters.status) {

                default:
                case 'Pending':
                    filterFunil = _.merge(filterFunil, {
                        and:
                        {
                            not: {
                                or: {
                                    ManagerGTMApproval: false,
                                    ManagerGTAApproval: false,
                                    SHEApproval: false ,
                                }
                            },
                            or: [
                                { ManagerGTMApproval: null },
                                {ManagerGTAApproval: null},
                                {SHEApproval: null}
                            ]
                        }
                        }
                       
                    )
                    break;
                case 'Approved':
                    filterFunil = _.merge(filterFunil, {
                        and: {
                            ManagerGTMApproval: true,
                            ManagerGTAApproval: true,
                            SHEApproval: true,
                        }
                    }
                    )
                    break;
                case 'Disapproved':
                    filterFunil = _.merge(filterFunil, {
                        or: {
                            ManagerGTMApproval: false,
                            ManagerGTAApproval: false,
                            SHEApproval: false,
                        }
                    }
                    )
                    break;
            }
        }

        // Structure
        if (!_.isEmpty(filters.structureId)) {
            filterStandard = _.merge(filterStandard, {
                standard: {
                    structureId: {
                        in: filters.structureId
                    }
                }
            })
            delete filterFunil.funil.structure;
            filterFunil = _.merge(filterFunil, {
                funil: {
                    structureId: {
                        in: filters.structureId
                    }
                }
            })

        }

        // Date fim
        if (filters.endDate != null) {
            filterStandard = _.merge(filterStandard, {
                createdAt: { le: filters.endDate }
            })
            filterFunil = _.merge(filterFunil, {
                createdAt: { le: filters.endDate }
            })
        }

        // Date inicio
        if (filters.startDate != null) {
            filterStandard = _.merge(filterStandard, {
                createdAt: { ge: filters.startDate }
            })
            filterFunil = _.merge(filterFunil, {
                createdAt: { ge: filters.startDate }
            })
        }

        // My Approval flux
        switch (filters.myfilter) {
            case 1:
                filterStandard = _.merge(filterStandard, {
                    standard: {
                        userId: getUser().id
                    }
                })
                filterFunil = _.merge(filterFunil, {
                    funil: {
                        GTMUserId: getUser().id
                    }
                }
                )
                break;
            case 2:
                filterStandard = _.merge(filterStandard, {
                    users: {
                        any: {
                            user: {
                                id: getUser().id
                            }
                        }
                    }
                })

                 // Status
                if (!_.isEmpty(filters.status)) {                   

                    switch (filters.status) {
                                              
                        case 'Pending':
                            break;
                        default:
                        case 'Approved':
                        case 'Disapproved':
                            filterFunilAuthorship = `(ManagerGTMApprovalUserId eq ${getUser().id} or ManagerGTAApprovalUserId eq ${getUser().id} or SHEApprovalUserId eq ${getUser().id}) and `
                            break;
                    }
                }
                else {
                    filterFunilAuthorship = `(ManagerGTMApprovalUserId eq ${getUser().id} or ManagerGTAApprovalUserId eq ${getUser().id} or SHEApprovalUserId eq ${getUser().id}) and `
                }
                break;
            default:
                break
        }

        let responseStandard = { _count: 0, value: [] };
        let responseFunil = { _count: 0, value: [] };
        let mergedResponse = { _count: 0, value: [] };
        const filteringFunil = filters.type.value?.includes('Funil') || filters.type.value?.includes('Todos');
        if (filteringFunil == false || _.isEmpty(filters.type)) {
            const response = await fetchTableOdata({
                filter: filterStandard,
                skip: (pagination.page - 1) * pagination.sizePerPage,
                top: pagination.sizePerPage,
                // Ordena pelo mais recente
                orderBy: ['CreatedAt desc']
            })
            if (response.status) {
                responseStandard = response.data;
            }
        }

        if ((filteringFunil == true || _.isEmpty(filters.type)) && _.isEmpty(filters.identifier) ) {
            const resp = await fetchTableFunilOdata({                
                skip: (pagination.page - 1) * pagination.sizePerPage,
                top: pagination.sizePerPage,
                // Ordena pelo mais recente
                orderBy: ['CreatedAt desc'],
                filter: filterFunil,
            }, filterFunilAuthorship)
            
            if (resp.status) {
                responseFunil = resp.data;
            }
        }

        let organizedFunil = [];
        responseFunil.value.forEach(el =>
        {
            var convertedObj = el;
            convertedObj.standard = {
                standardType: 'Funil',                
                user: {
                    name: el.funil.gtmUser.name
                },
                structure: {
                    name: el.funil.structure.name
                }                
            }
            var status = 'Pendente';
            var situation = 1;
            if (el.managerGTMApproval == false || el.managerGTAApproval == false || el.sheApproval == false)
            {
                status = 'Reprovado';
                situation = 3;
            }
            else {
                if (el.managerGTMApproval == true && el.managerGTAApproval == true && el.sheApproval == true) {
                    status = 'Aprovado';
                    situation = 2;
                }
            }
            convertedObj.situation = situation;
            convertedObj.status = status;

            organizedFunil.push(convertedObj);
        })

        mergedResponse._count = responseFunil._count + responseStandard._count;
        mergedResponse.value = _.orderBy(responseStandard.value.concat(organizedFunil), ['createdAt'], ['desc'])
       return mergedResponse
    }
)
